import { DashboardT } from 'business/definitions';

export const getPublicUrl = (dashboard: DashboardT) => {
    const { slug, publicToken } = dashboard;
    const host = window.location.hostname;
    if (slug && publicToken)
        return `https://${host}/public/dashboard/${slug}?public_token=${publicToken}`;
    return '';
};
